import { useQuery } from "react-query";
import { getRehireConfieEmployeeCount } from "../../../../../actions/Employees";

const useGetRehireConfieEmployeeCount = () => {
  return useQuery(
    "GetRehireConfieEmployeeCount",
    getRehireConfieEmployeeCount,
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useGetRehireConfieEmployeeCount;
